import './OfCalendar.scss'
import { useEffect, useRef, useState } from 'react'
import moment from 'moment'
import Week from './Week'
import 'moment/locale/tr'
import { ICalendarPlan } from '../../../types/CalendarType'
import { ICalendarSquads, IEmployeeSummary } from '../../../types/Employee'
import kocLogo from '../../../assets/icons/loading-calendar.png'
import AuthUtil from '../../../utils/AuthUtil'
import { useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actionCreators } from '../../../state/state-index'
import i18next from 'i18next'
import Loader from 'components/ui/Loader'
import CalendarHeader from './CalendarHeader'
import CalendarFooter from './CalendarFooter'

const OfCalendar = (props: {
  squadsEvents: ICalendarSquads[] | undefined
  events: ICalendarPlan[]
  selectedEmployee: IEmployeeSummary
  ofDay: any[] | undefined
  ofDayListCount: number
  showLoader: boolean
  showSquadsEvent: boolean
  isMyCalendar: boolean
  onChangeMonth: (arg0: any) => any
  onSelectDay: (arg0: any) => any
  handleMultipleCalendarSelectedDay: () => any
  filterSquadsEvents: (arg0: any) => any
}) => {
  let { events, squadsEvents, showSquadsEvent } = props
  const dispatch = useDispatch()
  const { createDaysState, cleanDaysState } = bindActionCreators(actionCreators, dispatch)
  const daysState = useSelector((state: any) => state.calendars)
  const employee = useRef<IEmployeeSummary | null>(null)

  /* States */
  let [month, setMonth] = useState(moment().locale(i18next.language))
  let [selected, setSelected] = useState(moment().startOf('day'))
  let [modalMonth, setModalMonth] = useState(moment().locale(i18next.language))
  const [backwardDaysReach, setBackwardDaysReach] = useState<number>(0)
  const [forwardDaysReach, setForwardDaysReach] = useState<number>(0)
  const [canGoBack, setCanGoBack] = useState(true)
  const [canGoForward, setCanGoForward] = useState(true)

  useEffect(() => {
    employee.current = AuthUtil.getEmployeeSummary()
    props.onChangeMonth(month.clone())
    setModalMonth(month.clone())
    setBackwardDaysReach(365) //Geçmişe yönelik bütün ayları görebilmek için "365" gün eklendi
    setForwardDaysReach(employee.current != null ? employee.current.futureOrientedDayCount : 0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    checkMonthNavLimits()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [backwardDaysReach, forwardDaysReach])

  useEffect(() => {
    setDaysState()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.events])

  useEffect(() => {
    props.onChangeMonth(month.clone())
    setModalMonth(month.clone())
    checkMonthNavLimits()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [month])

  const checkMonthNavLimits = () => {
    setCanGoBack(isDateValid(month.clone().subtract(1, 'months').endOf('month')))
    setCanGoForward(isDateValid(month.clone().add(1, 'months').startOf('month')))
  }

  const isDateValid = (date: moment.Moment) => {
    return (
      date.isSameOrAfter(moment().subtract(backwardDaysReach, 'days').endOf('day')) &&
      date.isSameOrBefore(moment().add(forwardDaysReach, 'days').startOf('day'))
    )
  }

  const select = (val: any) => {
    let { day } = val
    setSelected(day.date)
    props.onSelectDay(val)
  }

  const renderWeeks = () => {
    if (Object.keys(props.selectedEmployee).length > 0) {
      let weeks = []
      let done = false
      let mnth = month.clone().startOf('month').add('w-1').day(1)
      let date = mnth
      let count = 0
      let monthIndex = date.month()
      let dates = []
      let pastOrientedDate
      let futureOrientedDate

      if (employee.current !== null) {
        pastOrientedDate =
          month.clone().startOf('month') < moment().add(-1 * employee.current.pastOrientedDayCount, 'day')
            ? moment().add(-1 * employee.current.pastOrientedDayCount + -1, 'day')
            : month.clone().startOf('month')

        futureOrientedDate =
          month.clone().endOf('month') > moment().add(employee.current.futureOrientedDayCount, 'day')
            ? moment().add(employee.current.futureOrientedDayCount, 'day')
            : month.clone().endOf('month')
      }
      while (!done) {
        weeks.push(
          <Week
            key={date}
            date={date.clone()}
            month={month}
            showSquadsEvent={showSquadsEvent}
            squadsEvents={squadsEvents}
            events={events}
            select={(day: any) => select(day)}
            selected={selected}
          />
        )

        let day = {}
        for (var i = 0; i < 7; i++) {
          day = {
            name: date.clone().format('dd').substring(0, 1),
            number: date.clone().date(),
            isCurrentMonth: date.clone().month() === month.month(),
            isToday: date.clone().isSame(new Date(), 'day'),
            date: date.clone(),
            isChecked: false,
            isVisible: isVisible(date.clone(), pastOrientedDate, futureOrientedDate),
            isHolidayColor: isHolidayColorVisible(date.clone(), pastOrientedDate, futureOrientedDate),
            txtDay: holidayText(date.clone(), pastOrientedDate, futureOrientedDate),
            visibleHolidayText: holidayTextOpen(date.clone(), pastOrientedDate, futureOrientedDate),
          }
          let event = events.filter(
            (element: ICalendarPlan) => {
              const apiDate = String(element.reservationDate).substring(0, 10)
              const calendarDate = date.format('YYYY-MM-DD')
              return apiDate === calendarDate
            }
          )
          dates.push({ day: day, event: event.length > 0 ? event[0] : {} })

          date = date.clone()
          date.add(1, 'day')
          // if (i + 1 === 7) {
          //   date.add(3, 'day')
          // } else {
          // }
        }

        done = count++ > 2 && monthIndex !== date.month()
        monthIndex = date.month()
      }
      return weeks
    }
  }

  const setDaysState = () => {
    if (Object.keys(props.selectedEmployee).length > 0) {
      let done = false
      let mnth = month.clone().startOf('month').add('w-1').day(1)
      let date = mnth
      let count = 0
      let monthIndex = date.month()
      let dates = []
      let pastOrientedDate
      let futureOrientedDate

      if (employee.current !== null) {
        pastOrientedDate =
          month.clone().startOf('month') < moment().add(-1 * employee.current.pastOrientedDayCount, 'day')
            ? moment().add(-1 * employee.current.pastOrientedDayCount + -1, 'day')
            : month.clone().startOf('month')

        futureOrientedDate =
          month.clone().endOf('month') > moment().add(employee.current.futureOrientedDayCount, 'day')
            ? moment().add(employee.current.futureOrientedDayCount, 'day')
            : month.clone().endOf('month')
      }
      while (!done) {
        let day = {}
        for (var i = 0; i < 7; i++) {
          day = {
            name: date.clone().format('dd').substring(0, 1),
            number: date.clone().date(),
            isCurrentMonth: date.clone().month() === month.month(),
            isToday: date.clone().isSame(new Date(), 'day'),
            date: date.clone(),
            isChecked: false,
            isVisible: isVisible(date.clone(), pastOrientedDate, futureOrientedDate),
            isHolidayColor: isHolidayColorVisible(date.clone(), pastOrientedDate, futureOrientedDate),
            txtDay: holidayText(date.clone(), pastOrientedDate, futureOrientedDate),
            visibleHolidayText: holidayTextOpen(date.clone(), pastOrientedDate, futureOrientedDate),
          }
          let event = events.filter(
            (element: ICalendarPlan) => {
              const apiDate = String(element.reservationDate).substring(0, 10)
              const calendarDate = date.format('YYYY-MM-DD')
              return apiDate === calendarDate
            }
          )
          dates.push({ day: day, event: event.length > 0 ? event[0] : {} })
          date = date.clone()
          date.add(1, 'day')
          // if (i + 1 === 7) {
          //   date.add(3, 'day')
          // } else {
          //   date.add(1, 'day')
          // }
        }
        //date.add(1, 'w')
        done = count++ > 2 && monthIndex !== date.month()
        monthIndex = date.month()
      }
      createDaysState(dates)
    }
  }

  const isVisible = (date: any, pastOrientedDate: any, futureOrientedDate: any) => {
    if (
      employee.current?.id === props.selectedEmployee.id &&
      props.isMyCalendar === true &&
      date.isBetween(pastOrientedDate, futureOrientedDate, undefined, '[]')
    ) {
      const filtered = props.ofDay?.filter(
        (item: any) => String(item.dayOffDate).substring(0, 10) === moment(date).format('YYYY-MM-DD') && !item.dayOffIsReservable
      )
      if (filtered && filtered.length > 0) {
        return false
      } else {
        return true
      }
    } else {
      return false
    }
  }

  const isHolidayColorVisible = (date: any, pastOrientedDate: any, futureOrientedDate: any) => {
    const filtered = props.ofDay?.filter(
      (item: any) => String(item.dayOffDate).substring(0, 10) === moment(date).format('YYYY-MM-DD')
    )
    if (filtered && filtered.length > 0) {
      return false
    } else {
      return true
    }
  }

  const holidayText = (date: any, pastOrientedDate: any, futureOrientedDate: any) => {
    const filtered = props.ofDay?.filter(
      (item: any) => String(item.dayOffDate).substring(0, 10) === moment(date).format('YYYY-MM-DD')
    )
    if (filtered && filtered.length > 0) {
      return filtered[0]?.dayOffName
    }
  }
  const holidayTextOpen = (date: any, pastOrientedDate: any, futureOrientedDate: any) => {
    const filtered = props.ofDay?.filter(
      (item: any) => String(item.dayOffDate).substring(0, 10) === moment(date).format('YYYY-MM-DD')
    )
    return filtered && filtered.length > 0
  }

  return (
    <section id="ofCalendar" className="calendar of-bordered-box">
      {/* Calendar Content */}
      {props?.showLoader ? (
        <div className="loader-wrapper">
          <Loader src={kocLogo} />
        </div>
      ) : (
        <>
          <CalendarHeader
            cleanDaysState={cleanDaysState}
            employee={employee}
            isDateValid={isDateValid}
            filterSquadsEvents={props.filterSquadsEvents}
            modalMonth={modalMonth}
            setModalMonth={setModalMonth}
            month={month}
            setMonth={setMonth}
            showSquadsEvent={showSquadsEvent}
            selectedEmployee={props.selectedEmployee}
            showLoader={props.showLoader}
            canGoBack={canGoBack}
            canGoForward={canGoForward}
          />

          {renderWeeks()}

          <CalendarFooter
            employee={employee}
            selectedEmployee={props.selectedEmployee}
            daysState={daysState}
            handleMultipleSelectedDay={props.handleMultipleCalendarSelectedDay}
            events={events}
            month={month}
            showSquadsEvent={showSquadsEvent}
            squadsEvents={squadsEvents}
          />
        </>
      )}
    </section>
  )
}

export default OfCalendar
